import { TimePicker } from '@mui/x-date-pickers'
import { Stack, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'
import { t } from 'i18next'
import dayjs from 'dayjs'
import DateFormat from '../../store/types/enums/DateFormat'

type DefaultWorkingHoursPickersProps = {
  startTime: string
  setStartTime: Dispatch<SetStateAction<string>>
  endTime: string
  setEndTime: Dispatch<SetStateAction<string>>
  isError: boolean
}

const DefaultWorkingHoursPickers = ({
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  isError,
}: DefaultWorkingHoursPickersProps) => {
  return (
    <Stack>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={{ justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
      >
        <TimePicker
          ampm={false}
          value={dayjs(startTime, DateFormat.HourMinute)}
          onChange={newValue => {
            if (newValue) {
              setStartTime(newValue.format(DateFormat.HourMinute))
            }
          }}
          label={t('components.settingsDialog.start')}
          sx={{ width: { xs: '100%', sm: 120 } }}
          slotProps={{
            textField: { size: 'small', error: isError },
          }}
        />
        <TimePicker
          ampm={false}
          value={dayjs(endTime, DateFormat.HourMinute)}
          onChange={newValue => {
            if (newValue) {
              setEndTime(newValue.format(DateFormat.HourMinute))
            }
          }}
          label={t('components.settingsDialog.end')}
          sx={{ width: { xs: '100%', sm: 120 } }}
          slotProps={{
            textField: { size: 'small', error: isError },
          }}
        />
      </Stack>
      {isError && (
        <Typography variant="caption" color="error.main" pt={0.5} pl={1}>
          {t('components.settingsDialog.hoursError')}
        </Typography>
      )}
    </Stack>
  )
}

export default DefaultWorkingHoursPickers
